/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React from 'react';
import QueryNavbar from "../components/AppNavbar";

import { isUserSignedIn, isUserProfileLoaded, UserContext, getUserFirstName, getLinkForSignIn } from "../UserContext";
import { formatRelativeDate } from '../helpers/DateHelper';

import TicketNotFound from "./TicketNotFound";
import Loading from "../components/Loading";

import HelpDeskImg from '../assets/svg/stories/helpdesk.svg';
import NewAccountImg from '../assets/svg/illustrations/account-creation.svg';
import SignInToSharePromoPage from './SignInToSharePromoPage';
import {withRouter} from "react-router-dom";

const PRIVACY_MAP = [
    {
        id: "PRIVACY_NONE",
        title: 'Show all data',
        subtitle: 'Maximum detail for support',
        badge: <span className="badge badge-pill badge-navy py-1 px-2"><span className="fa fa-search fa-fw mr-2" /> Best for analysis</span>
    },
    {
        id: "PRIVACY_NONPERSONAL",
        title: 'Show non-personal data',
        subtitle: 'Hide device names, Internet address and location',
        badge: <span className="badge badge-pill badge-navy py-1 px-2"><span className="fas fa-shield-alt fa-fw mr-2" /> Best for privacy</span>
    },
    {
        id: "PRIVACY_MAX",
        title: 'Show minimal data',
        subtitle: 'Hide all device details, Internet address and location',
        badge: <span className="h-4rem">&nbsp;</span>
    }
];

// const fakeTicket = {
//     ticketId: "C9727538A443099C",
//     state: "NEW",
//     userId: "god@fing.io",
//     newTicketCommunityUser: "carlo@ciao.com",
//     creationDate: 1573035310000,
//     "lastAccessDate": 0,
//     "lastAccessBy": null,
//     "totalViews": 0,
//     sharedUserIds: null,
//     communityDiscussionId: '32823',
//     sharePIN: "6EE0BD",
//     title: null,
//     description: null,
//     privacy: null,
//     healthCheck: {
//         timestamp: 1573030985220,
//         id: "NO_DEVICE1573030985220",
//         totalChecks: 18,
//         self: null,
//         gateway: null,
//         checks: [{
//             segment: "internet",
//             type: "801",
//             status: "OK",
//             info: "Connected to Internet via COLT in Italy, Internet IP 87.241.41.114"
//         },
//         {
//             segment: "internet",
//             type: "802",
//             status: "FAIL",
//             info: "DNS service is not working: test domain netflix.com not resolved"
//         },
//         {
//             segment: "internet",
//             type: "803",
//             status: "INFO",
//             info: "COLT is a business ISP"
//         }]
//     },
//     netSummary: {
//         lastDiscoveryTime: 1573661285030,
//         totDevices: 208
//     }
// };

class OpenHelpTicketView extends React.Component {

    static contextType = UserContext;

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isFound: false,
            privacy: "PRIVACY_NONE",
            cpToClipText: "Copy to Clipboard",
            ticket: null,
            isTargetSelection: true,
            isPostToCommunity: false
        };

        // Bindings
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleChangeFilter = this.handleChangeFilter.bind(this);
        this.handlePostCommunity = this.handlePostCommunity.bind(this);
        this.handlePostTicket = this.handlePostTicket.bind(this);
    }

    componentDidMount() {
        this.fetchTicket();
    }

    // --------------------------------------------------------------------------------
    // UTILS
    // --------------------------------------------------------------------------------

    validateRestResponse(response) {
        if (response.status !== 200) {
            throw Error(response.statusText);
        }
        return response;
    }

    catchRestError(error) {
        console.error(error);
        this.setState({ isLoading: false, isFound: false });
    }

    fetchTicket() {
        this.setState({ isLoading: true, isFound: false });
        const url = '/rest/internet/helpme/helpticket/' + this.props.match.params.ticketid;
        // return this.setState({ ticket: fakeTicket, isLoading: false, isFound: true });
        fetch(url)
            .then(response => this.validateRestResponse(response))
            .then(response => {
                console.log(response);
                return response.json();
            })
            .then(data => {
                this.setState({ ticket: data, isLoading: false, isFound: true });
            })
            .catch(e => this.catchRestError(e))
            ;
    }

    countTypeOfCheck(checks) {
        let counter = {
            all: checks.length,
            ok: 0,
            info: 0,
            warn: 0,
            fail: 0
        };

        for (const check of checks) {
            switch (check.status) {
                case 'OK':
                    counter.ok++;
                    break;
                case 'INFO':
                    counter.info++;
                    break;
                case 'WARN':
                    if (check.muted === 'false') counter.warn++;
                    else counter.info++;
                    break;
                case 'FAIL':
                    counter.fail++;
                    break;
                default:
                    break;
            }
        }
        return counter;
    }

    // --------------------------------------------------------------------------------
    // HANDLERS
    // --------------------------------------------------------------------------------

    handlePostCommunity() {
        this.setState({ isTargetSelection: false, isPostToCommunity: true });
    }

    handlePostTicket() {
        this.setState({ isTargetSelection: false, isPostToCommunity: false });
    }

    handleChangeFilter(event) {
        // event.preventDefault();
        console.log('CURRENT ', event.currentTarget.id);
        this.setState({ privacy: event.currentTarget.id });
    };

    handleFormSubmit(event) {
        event.preventDefault();

        const { ticket, isPostToCommunity } = this.state;
        let community = isPostToCommunity && ticket.newTicketCommunityUser != null;

        let formTitle, formDescription, formPrivacy;

        formTitle = event.target['formTitle'] ? event.target['formTitle'].value : '';
        formDescription = event.target['formDescription'] ? event.target['formDescription'].value : '';
        formPrivacy = event.target['formPrivacy'] ? PRIVACY_MAP.filter(p => p.id === event.target['formPrivacy'].value)[0].id : '';

        const newTicket = Object.assign({}, ticket);
        newTicket.title = formTitle;
        newTicket.description = formDescription;
        newTicket.privacy = formPrivacy;
        newTicket.communityDiscussionId = community ? community.toString() : '';
        newTicket.state = 'OPEN';

        const url = '/rest/internet/helpme/manageticket';
        console.log('calling POST: ' + url);

        fetch(url, {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(newTicket)
        })
            .then(response => this.validateRestResponse(response))
            .then(response => {
                return response.json();
            })
            .then(data => {
                this.setState({ ticket: data });
            })
            .catch(e => this.catchRestError(e));
    };

    // --------------------------------------------------------------------------------
    // ANCILLARY RENDER FUNCTION
    // --------------------------------------------------------------------------------

    renderHealthTextSummary() {
        const { ticket } = this.state;

        if (!ticket || !ticket.healthCheck || (!ticket.healthCheck.checks || ticket.healthCheck.checks.length === 0)) return "";

        const counter = this.countTypeOfCheck(ticket.healthCheck.checks);

        const netSummary = ticket.netSummary || null;

        return (
            <div>
                <ul className="list-inline">
                    <li className="list-inline-item d-inline-flex align-items-center">
                        <span className="legend-indicator bg-success"/>{counter.ok} checks passed
                    </li>
                    <li className="list-inline-item d-inline-flex align-items-center">
                        <span className="legend-indicator bg-warning"/>{counter.warn} checks with warning
                    </li>
                    <li className="list-inline-item d-inline-flex align-items-center">
                        <span className="legend-indicator bg-danger"/>{counter.fail} checks failed
                    </li>
                    {netSummary && netSummary.totDevices &&
                    <li className="list-inline-item d-inline-flex align-items-center">
                        <span className="legend-indicator bg-info"/>{netSummary.totDevices} devices, updated {formatRelativeDate(netSummary.lastDiscoveryTime)}
                    </li>
                    }
                </ul>
            </div>
        )
    }

    renderCommunityPromo() {
        // king of the pigs: here to be handled with proper timer maybe ;)
        // TODO: Fixme first things first
        const handleRefresh = () => this.fetchTicket();
        setTimeout(handleRefresh, 5000);

        return (
            <div className="container">
                <div className="card w-lg-80 mx-lg-auto">
                    <div className='card-header flex-column px-8'>
                        <h3 className="h2 font-weight-medium">Register on <strong className='text-primary'>Fing Community</strong></h3>
                        <p className="h5">You need to enable your existing Fing account on Fing Community to post your query.</p>
                        <p>Please register and come back here.</p>
                    </div>
                    <div className="card-body text-center mt-4 mb-2">
                        <a className="btn btn-primary btn-wide" href='https://community.fing.com' target="_blank" rel="noopener noreferrer">
                            Register now
                                </a>
                        <figure>
                            <img className="img-fluid w-40 max-w-40rem p-1" src={NewAccountImg} alt="Account needed" />
                        </figure>
                    </div>
                </div>
            </div>
        );
    }

    renderTargetSelection() {
        return (
            <div className="container">
                <div className="w-lg-80 mx-lg-auto">
                    <div className="text-center">
                        <figure>
                            <img className="img-fluid w-80 max-w-40rem p-1" src={HelpDeskImg} alt="Get free help" />
                        </figure>
                    </div>
                    <div className="row">
                        <div className="card border shadow-sm p-4 col-md-6 mx-auto">
                            <h1 className="h5 card-title font-weight-medium mb-0">
                                Share link with IT Support Teams
                                </h1>
                            <h2 className="h6 text-secondary">
                                Create a report that you can share with IT Support Teams to get advice on your connectivity issues.
                                </h2>
                            <span>
                                <button className="btn btn-primary btn-xs btn-wide transition-3d-hover mt-5" onClick={this.handlePostTicket}>
                                    Create a sharable link
                                </button>
                            </span>
                        </div>
{/*
                        <div className="card shadow-sm p-4 col-md-6">
                            <h1 className="h5 card-title font-weight-medium mb-0">Ask on Fing Community</h1>
                            <h2 className="h6 text-secondary">Post your query to the Fing Community where Community members can help you troubleshoot your issues.</h2>
                            <span>
                                <button className="btn btn-purple btn-wide transition-3d-hover mt-5" onClick={this.handlePostCommunity}>
                                    Post to Fing Community
                                </button>
                            </span>
                        </div>
*/}
                    </div>
                </div>
            </div>
        );
    }

    renderTicketOpen() {
        const {ticket} = this.state;
        const linkView = "https://query.fing.com/" + ticket.ticketId;
        let commLink = null;
        var msgDescr = "Share the link below with IT Support Teams that may help you solve the issue.";
        var msgTitle = "Your sharable report has been created!";
        if (ticket.communityDiscussionId && ticket.communityDiscussionId !== '') {
            commLink = "https://community.fing.com/discussion/" + ticket.communityDiscussionId;
            msgDescr = "A confirmation email has been sent to you.";
            msgTitle = "Your question has been submitted to the Fing Community!";
        }

        const emailSubject = "Can you help me with my connectivity issues?";
        const emailBody = `Hi,\n\nhere you can find my connectivity report from Fing Desktop with full details: ${linkView}\n\n${getUserFirstName(this.context)}`;

        return (
            <div className="container space-2">
                <div className="w-md-80 w-lg-50 text-center mx-md-auto">
                    <div className="btn btn-lg btn-icon btn-pill btn-success">
                        <span className={"fas fa-check btn-icon__inner text-white"} />
                    </div>
                    <div className="mb-5">
                        <h3 className="font-weight-medium mt-3 mb-0">{msgTitle}</h3>
                        <p className="max-w-5rem0 mx-auto">{msgDescr}</p>
                        {!commLink && <a className="text-secondary small link-underline m-0" href={linkView}>{linkView}</a>}
                    </div>
                    <div className="d-flex flex-column justify-content-center">
                        <div>
                            {!commLink && <a className="btn btn-primary btn-pill w-60 transition-3d-hover mx-2" href={linkView}>Open page</a>}
                            {commLink && <a className="btn btn-primary w-60 btn-pill transition-3d-hover mx-2" href={commLink}>Go to discussion</a>}
                        </div>
                        {!commLink &&
                            <div className="d-flex flex-column justify-content-center">
                                <span className='py-5 text-muted'>or share directly</span>
                                <button className="btn btn-xs btn-outline-charcoal btn-pill transition-3d-hover w-50 mb-2 mx-auto"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigator.clipboard.writeText(linkView);
                                        this.setState({ cpToClipText: "Copied!" });
                                    }}>
                                    {this.state.cpToClipText}
                                </button>
                                <a className="btn btn-xs btn-outline-charcoal btn-pill transition-3d-hover w-50 mb-2 mx-auto"
                                    href={`mailto:?headers=content-type: text/plain&subject=${encodeURI(emailSubject)}&body=${encodeURI(emailBody)}`}>Send via email</a>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }

    renderTicketNew() {
        const { isTargetSelection } = this.state;
        if (isTargetSelection) { // Select if create ticket or Community
            return this.renderTargetSelection();
        }
        
        const { isPostToCommunity, ticket } = this.state;
        if (isPostToCommunity && !ticket.newTicketCommunityUser) { // Chosen Community but w/o account
            return this.renderCommunityPromo();
        }

        let { privacy } = this.state;
        if (!privacy) {
            privacy = "PRIVACY_NONE";
        }

        let title, subtitle, titlePlaceholder, descrPlaceholder,  buttonTitle;
        if (isPostToCommunity) {
            title = 'Post to Fing Community';
            subtitle =  'Your query will be posted to the Fing Community, where other members can advise you on your connectivity and security issues.'
            titlePlaceholder = 'Enter a meaningful summary title of your issue.';
            descrPlaceholder = 'Say hello, describe your issue and be as descriptive and specific as possible. Include any devices, operating systems and relevant details about your network to get the best answers.';
            buttonTitle = 'Post question to Fing Community';

        } else {
            title = 'Complete your request';
            subtitle = 'You will get a simple link to share with your IT Support Team to troubleshoot your connectivity and security issues.';
            titlePlaceholder = 'Enter a title';
            descrPlaceholder = 'Enter a short description of your internet problems';
            buttonTitle = 'Share link with your IT Support Team';
        }

        return (
            <div className="container space-1">
                <h2 className="card-title font-weight-semi-bold mb-0">{title}</h2>
                <p className="mb-3">{subtitle}</p>
                <div className="card card-bordered">
                    <div className="card-body">
                        <form id="formTicket" onSubmit={this.handleFormSubmit}>
                            <div className="form-group mb-3">
                                <h3 className="h4 d-block">Your report's summary</h3>
                                {this.renderHealthTextSummary()}
                            </div>
                            <div className="form-group mb-3">
                                <label className="h4" htmlFor="formTitle">Title</label>
                                <input id="formTitle" className="form-control" type="text" defaultValue={this.state.title} placeholder={titlePlaceholder} required />
                            </div>
                            <div className="form-group mb-3">
                                <label className="h4 d-block" htmlFor="formDescription">Description</label>
                                <textarea id="formDescription" className="form-control" defaultValue={this.state.description} placeholder={descrPlaceholder} rows="3" required />
                            </div>
                            <div className="form-group mb-6">
                                <input id="formPrivacy" className="d-none form-control" defaultValue={this.state.privacy} required />
                                <label className="h4 d-block" htmlFor="formPrivacy">Privacy</label>
                                <div className="mx-auto">
                                    <div className="btn-group">
                                        {PRIVACY_MAP.map(privacyLevel => this.renderPrivacyCard(privacyLevel, privacy === privacyLevel.id))}
{/*
                                        {PRIVACY_MAP.map(privacyLevel =>
                                            <label id={privacyLevel.id}
                                                   className={classes[privacyLevel.id.toLowerCase()]}
                                                   onClick={this.handleChangeFilter}><input type="radio" name="options" />
                                            {privacyLevel.badge && <div className="text-center">{privacyLevel.badge}</div>}
                                            <div className="card-body">
                                                <span className="text-dark">{privacyLevel.title}</span>
                                                <small className="d-block text-secondary">{privacyLevel.subtitle}</small>
                                            </div></label>)
                                        }
*/}
                                    </div>
                                </div>
                            </div>
                            <button className="btn btn-primary btn-wide" type="submit" id="formBtnShare"
                                onClick={(event) => event.target.form['formBtnCommunity'].value = ""}>
                                {buttonTitle}
                            </button>

                        </form>
                    </div>
                </div>
            </div>
        );
    }

    renderPrivacyCard(privacyLevel, selected) {
        const id = privacyLevel.id;
        const changeFilter = (e) => {
            this.setState({ privacy: id })
        };

        return (
            <div key={id} className="custom-control custom-radio custom-control-inline checkbox-outline checkbox-icon w-100 mx-1">
                <input type="radio" id={"input_" + privacyLevel.id} name="privacyGroup"
                       className="custom-control-input checkbox-outline-input checkbox-icon-input"
                       checked={selected}
                       onChange={changeFilter}
                />
                <label className={"checkbox-outline-label checkbox-icon-label w-100 rounded-lg p-4" + (selected ? " bg-soft-primary" : "")}
                       htmlFor={"input_" + privacyLevel.id}
                       onChange={changeFilter}
                >
                    {privacyLevel.badge && <div className="text-center mb-3 mt-n3">{privacyLevel.badge}</div>}
                    <h4 className="mb-0">{privacyLevel.title}</h4>
                    <p className="font-size-1">{privacyLevel.subtitle}</p>
                </label>
            </div>
        );
    }

    // --------------------------------------------------------------------------------
    // MAIN RENDER
    // --------------------------------------------------------------------------------

    render() {
        const { isLoading, isFound, ticket } = this.state;

        if (isLoading || !isUserProfileLoaded(this.context)) {
            return <Loading />
        }

        if (!isUserSignedIn(this.context)) {
            return <SignInToSharePromoPage link={getLinkForSignIn(this.context, window.location.href)} />;
        }

        if (!isFound || ['NEW', 'OPEN'].indexOf(ticket.state) === -1) {
            return <TicketNotFound />;
        }

        return (
            <div>
                <QueryNavbar />
                <main id="content" role="main">
                    {ticket.state === 'OPEN' ? this.renderTicketOpen() : /* ticket.state === 'NEW'*/ this.renderTicketNew()}
                </main>
            </div>
        );

    }
}

export default withRouter(OpenHelpTicketView)